/**
 * @description 微信分享工具类
 */
import {checkEventCollect, collectionUserAction, weChatServer} from "./Rescource";
import Config from "./Config";
import {isNotLoggedIn} from "./IntegratedProcessing";

export default class WechatShareUtil {
	/**
	 * @params{String} appId 公众号配置appId
	 * @params{String} apiUrl 获取授权签名接口
	 * @params{String} link
	 * @params{String} title 分享标题
	 * @params{String} desc 分享描述
	 * @params{String} imgUrl 分享图标
	 */
	constructor(options) {
		const {appId, apiUrl, ...shareInfo} = options
		if (!appId) return
		this.weChatServerInject = Config.weChatServerInject
		// 微信公众号appId
		this.appId = appId
		// 自定义分享内容
		this.shareInfo = shareInfo
		this._init()
	}

	_init() {
		const {appId} = this
		const url = window.location.href.split('#')[0]
		const params = {appId, url}
		if (this.weChatServerInject) {
			this._shareInit()
			return
		}
		weChatServer({params}).then(res => {
			if (res.message === 'success') {
				let data = res.data
				/* eslint-disable */
				window.wx && wx.config({
					debug: false,
					appId: data.appId,
					jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'], // hideMenuItems
					timestamp: data.timestamp,
					nonceStr: data.nonceStr,
					signature: data.signature
				})
				this._shareInit()
			}
		})
	}

	_shareInit() {
		/* eslint-disable */
		wx.ready(() => {
			Config.weChatServerInject = true
			// 屏蔽其他一些功能
			/* eslint-disable no-undef */
			wx.hideMenuItems({
				menuList: ['menuItem:share:qq', 'menuItem:share:QZone', 'menuItem:share:weiboApp', 'menuItem:copyUrl', 'menuItem:openWithSafari', 'menuItem:openWithQQBrowser']
			})
			// 分享给朋友或分享到QQ
			/* eslint-disable no-undef */
			wx.onMenuShareAppMessage({
				link: this.shareInfo.link,
				title: this.shareInfo.title,
				desc: this.shareInfo.desc,
				imgUrl: this.shareInfo.imgUrl,
				success: () => { // 设置成功
					this.openReward()
				}
			})
			// 分享到朋友圈
			/* eslint-disable no-undef */
			wx.onMenuShareTimeline({
				link: this.shareInfo.shareMomentsUrl,
				title: this.shareInfo.title,
				desc: this.shareInfo.desc,
				imgUrl: this.shareInfo.imgUrl,
				success: () => { // 设置成功
					this.openReward()
				}
			})
		})
		// wx.error((res) => {
		//   console.log(res)
		//   // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
		// })
	}

	// 登记用户分享行为
	openReward = () => {
		if (!Config.fzsOpenId) return
		collectionUserAction({
			actionParams: {
				actionNo: Config.shareActionNo,
				actionCode: ''
			},
			voucherParams: {
				voucherKey: 'openId',
				voucherValue: Config.fzsOpenId
			}
		})
		!isNotLoggedIn() && checkEventCollect()
	}

}
